import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Importar Bootstrap correctamente
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// O si prefieres usar CDN, debes usar un script tag en el HTML, no un import

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);